import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import {
    Body as AccordionBody,
    Header as AccordionHeader,
    Title as AccordionTitle,
    Wrapper as AccordionWrapper,
} from '@r1-frontend/ui-react/components/accordions/Accordion';
import { TTheme } from '@r1-frontend/ui-react/components/accordions/Accordion/themes';
import WideContainer from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { FullWidthListContainer, IndentContainer, ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { Footer } from '~/src/components/Footer';
import IndentContainerWithBackground from '~/src/features/internetV2/components/IndentContainerWithBackground';
import { PromoTextWithStyleHeading2 } from '~/src/features/internetV2/components/typography';
import { toggleAnswer } from '~/src/features/internetV2/store/actions';
import { selectArticles } from '~/src/features/internetV2/store/selectors';

import { TableStyle } from '~/src/features/internet/generateTariffSummaryTableFAQ/styled';

const theme: TTheme = {
    border: COLORS.BgMain,
    background: COLORS.BgMain,
    radius: BorderRadius.InnerBlockRadius,
    padding: '16px 24px',
    mobilePadding: '16px 24px',
    storyColor: COLORS.BgMain,
    color: COLORS.TextPrimary,

    colorArrow: COLORS.GRAY_DARK,
    colorArrowIsOpen: COLORS.GRAY_DARK,

    buttonType: 'secondary',

    backgroundIcon: COLORS.Outline_Light,
    borderIcon: COLORS.Outline_Light,
    backgroundIconIsOpen: COLORS.Outline_Light,
    borderIconIsOpen: COLORS.Outline_Light,
};

const Paragraph = styled(Paragraph4)`
    ${TableStyle};
`;

export const FAQContainer = (): JSX.Element => {
    const dispatch = useDispatch();

    const articles = useSelector(selectArticles);

    return (
        <IndentContainerWithBackground
            $desktop={[48, 0, 0]}
            $mobile={[64, 0, 0]}
        >
            <WideContainer>
                <IndentContainer $united={[0, 8]}>
                    <FullWidthListContainer $wrap={'nowrap'} $direction={'column'} $size={24}>
                        <PromoTextWithStyleHeading2 as={'h2'}>Если остались вопросы</PromoTextWithStyleHeading2>
                        <ListContainer
                            $direction={'column'}
                            $size={12}
                            itemScope
                            itemType='https://schema.org/FAQPage'
                        >
                            {
                                articles.map(article => {
                                    const { question, answer, key, isOpen } = article;

                                    return (
                                        <AccordionWrapper
                                            key={key}
                                            theme={theme}
                                            itemProp={'mainEntity'}
                                            itemScope
                                            itemType='https://schema.org/Question'
                                        >
                                            <AccordionHeader
                                                onOpen={() => dispatch(toggleAnswer(article))}
                                                colors={theme}
                                                isOpen={isOpen}
                                            >
                                                <AccordionTitle itemProp={'name'}>
                                                    <IndentContainer $united={[0, 8, 0, 0]}>
                                                        {question}
                                                    </IndentContainer>
                                                </AccordionTitle>
                                            </AccordionHeader>
                                            <AccordionBody
                                                isOpen={isOpen}
                                                withDividingBorder={false}
                                            >
                                                <IndentContainer $united={[8, 0, 0]}>
                                                    <Paragraph
                                                        itemProp='acceptedAnswer'
                                                        itemScope
                                                        itemType='https://schema.org/Answer'
                                                        $color={COLORS.TextSecondary}
                                                        as={'article'}
                                                        dangerouslySetInnerHTML={{ __html: answer }}
                                                    />
                                                </IndentContainer>
                                            </AccordionBody>
                                        </AccordionWrapper>
                                    );

                                })
                            }
                        </ListContainer>
                    </FullWidthListContainer>
                </IndentContainer>
            </WideContainer>

            <Footer withChat/>
        </IndentContainerWithBackground>
    );
};
